export const companiesConstants = {
  UPDATE_COMPANY: '[Companies] Update',
  REMOVE_COMPANY: '[Companies] Remove',
  LOADING_COMPANIES: '[Companies] Loading',
  LOADING_COMPANIES_ERROR: '[Companies] Loading error',
  COMPANY_AJAX_CALL: '[Companies] Ajax call',
  COMPANY_AJAX_SUCCESS: '[Companies] Ajax success',
  COMPANY_AJAX_FAILURE: '[Companies] Ajax error'
}
